<div class="wrapper">
  @for (program of activeSubscriptions(); track program.id) {
    <app-program-card (manage)="goToProgram(program)" [program]="program"></app-program-card>
  }
</div>